import { render, staticRenderFns } from "./MemberChangePassword.vue?vue&type=template&id=b288181e&"
import script from "./MemberChangePassword.vue?vue&type=script&lang=js&"
export * from "./MemberChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./MemberChangePassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports